module.exports = __webpack_public_path__ + "img/alert-triangle-red.94c4c0de.svg";